import AppSettings from "../../core/AppSettings";
import vaultConstants from "../../../config/vault_constants";

export const get_FF_1745770_USE_AZURE_WALLET_WIDGET = () => {
    return AppSettings.isLocalHost ? true : String(vaultConstants.FF_1745770_USE_AZURE_WALLET_WIDGET) === "true";
};
